import React from 'react';
import BusinessCenterOutlinedIcon from '@mui/icons-material/BusinessCenterOutlined';
import PublicOutlinedIcon from '@mui/icons-material/PublicOutlined';
import SettingsOverscanOutlinedIcon from '@mui/icons-material/SettingsOverscanOutlined';
import SyncAltOutlinedIcon from '@mui/icons-material/SyncAltOutlined';
import ConstructionOutlinedIcon from '@mui/icons-material/ConstructionOutlined';
import HandshakeOutlinedIcon from '@mui/icons-material/HandshakeOutlined';

const excellenceList = [
  { icon: <BusinessCenterOutlinedIcon />, title: "Enterprise Delivery", desc: "Structured workflows and scalable development practices designed for long-term growth." },
  { icon: <PublicOutlinedIcon />, title: "Multi-Region Operations", desc: "Supporting clients across Botswana and South Africa through localized operations." },
  { icon: <SettingsOverscanOutlinedIcon />, title: "Scalable Infrastructure", desc: "Cloud-ready systems engineered for performance, reliability, and security." },
  { icon: <SyncAltOutlinedIcon />, title: "Agile Development", desc: "Fast, adaptive delivery cycles tailored to business and institutional needs." },
  { icon: <ConstructionOutlinedIcon />, title: "Long-Term Support", desc: "Continuous maintenance, monitoring, and system optimization after deployment." },
  { icon: <HandshakeOutlinedIcon />, title: "Strategic Partnerships", desc: "Collaborative delivery model enabling expansion and specialist integration when required." }
];

const OperationalExcellence = () => {
  return (
    <section className="section op-excellence-section">
      <div className="container">
        <h2 className="text-center mb-1">Operational Excellence</h2>
        <div style={{ display: 'flex', justifyContent: 'center' }}>
          <div className="divider-short" style={{ marginBottom: '4rem' }}></div>
        </div>
        
        <div className="op-excellence-grid">
          {excellenceList.map((item, index) => (
            <div key={index} className="op-card">
              <div className="icon">{item.icon}</div>
              <h4>{item.title}</h4>
              <p>{item.desc}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default OperationalExcellence;
